export default __webpack_public_path__ + "static/seasons-of-thought-cover-aaee5f8c0636040f634792a84a6e6b3f.png";